export const TYPE = {
    THUMBS: 'thumbs',
    RESIZED: 'resized'
};


// WEBPACK FOOTER //
// ./src/constants/Image.js